
import React from 'react';

interface ProfileCompletionGuideProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProfileCompletionGuide = ({ isOpen, onClose }: ProfileCompletionGuideProps) => {
  // Always return null to prevent the modal from rendering
  return null;
};

export default ProfileCompletionGuide;
